package org.hs_soft.runmynesto.pages.home.sub_page.options.component.tabs.restaurant_manager.components.dialogs

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.text.SpanText
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.FontFamily
import org.hs_soft.runmynesto.domain.config.FontLineHeight
import org.hs_soft.runmynesto.domain.config.FontSizes
import org.hs_soft.runmynesto.domain.config.LetterSpacing
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.backgroundDialog
import org.hs_soft.runmynesto.domain.config.generalDialogSetting
import org.hs_soft.runmynesto.domain.model.general.ButtonTypes
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.CashRegisterTypeEnum
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.DeviceTypeEnum
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.Children
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.ChildrenX
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.ChildrenXX
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.ChildrenXXX
import org.hs_soft.runmynesto.domain.util.Res
import org.hs_soft.runmynesto.domain.util.extractAllCashRegisters
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.CheckboxComponent
import org.hs_soft.runmynesto.pages.components.CircleIcon
import org.hs_soft.runmynesto.pages.components.CustomEditText
import org.hs_soft.runmynesto.pages.components.CustomRadioInput
import org.hs_soft.runmynesto.pages.components.DropDownItem
import org.hs_soft.runmynesto.pages.components.Separator
import org.hs_soft.runmynesto.pages.components.dialog.component.CustomButton
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.RadioGroup

@Composable
fun AddNewDeviceToCashRegistersDialog(
    windowSizeMode: WindowSizeModeEnum,
    loading:Boolean,
    selectedOffice: Children?,
    selectedRegion: ChildrenX?,
    selectedBranch: ChildrenXX?,
    cashList: List<Children>?,
    onDismissDialog: () -> Unit,
    onSelectOffice: (Children?) -> Unit,
    onSelectRegion: (ChildrenX?) -> Unit,
    onSelectShop: (ChildrenXX?) -> Unit,
    createNewDepartment:(String)->Unit,
    createNewRegion:(String,String)->Unit,
    createNewShop:(String,String)->Unit,
    createCashRegister:(DeviceTypeEnum,String,String,String,String,Boolean, )->Unit,
)
{
    val selectedCashType= remember { mutableStateOf(CashRegisterTypeEnum.ADD_NEW_CASH_REGISTER) }

    Box(
        modifier = Modifier
            .backgroundDialog()
            .onClick {
                onDismissDialog()
            }
    )
    {
        Column(
            modifier = Modifier
                .align(Alignment.Center)
                .generalDialogSetting()
                .width(
                    when(windowSizeMode){
                        WindowSizeModeEnum.PHONE->Dimen.addNewDeviceToCashRegistersDialogMobileWidth
                        else->Dimen.addNewDeviceToCashRegistersDialogWidth
                    }
                )
                .height(Dimen.addNewDeviceToCashRegistersDialogHeight)
        ){
            TopToolbar(
                onDismissDialog={
                    onDismissDialog()
                }
            )

            CashRegisterTypeFilters(
                windowSizeMode=windowSizeMode,
                selectedFilterType =selectedCashType.value,
                onSelectFilterType = {
                    selectedCashType.value=it
                }
            )

            Separator()

            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(Dimen.mediumPadding)
            )
            {
                when(selectedCashType.value){

                    CashRegisterTypeEnum.ADD_NEW_BUSINESS_OFFICE ->{
                        AddNewBusinessOffice(
                            loading=loading,
                            createNewDepartment={ name->
                                createNewDepartment(name)
                            }
                        )
                    }
                    CashRegisterTypeEnum.ADD_NEW_REGION ->{
                        AddNewRegion(
                            loading=loading,
                            selectedOffice=selectedOffice,
                            cashList=cashList,
                            onSelectOffice = {
                               onSelectOffice(it)
                            },
                            createNewRegion={id:String,name:String->
                                createNewRegion(id,name)
                            }
                        )
                    }
                    CashRegisterTypeEnum.ADD_NEW_BRANCH ->{
                        AddNewBranch(
                            loading=loading,
                            selectedOffice=selectedOffice,
                            selectedRegion=selectedRegion,
                            cashList=cashList,
                            onSelectOffice = {
                                onSelectOffice(it)
                            },
                            onSelectRegion = {
                                onSelectRegion(it)
                            },
                            createNewShop={id:String,name:String->
                                createNewShop(id,name)
                            }
                        )
                    }
                    CashRegisterTypeEnum.ADD_NEW_CASH_REGISTER ->{
                        AddNewCashRegister(
                            loading=loading,
                            windowSizeMode=windowSizeMode,
                            selectedOffice=selectedOffice,
                            selectedRegion=selectedRegion,
                            selectedBranch=selectedBranch,
                            cashList=cashList,
                            onSelectOffice = {
                                onSelectOffice(it)
                            },
                            onSelectRegion = {
                                onSelectRegion(it)
                            },
                            onSelectShop = {
                                onSelectShop(it)
                            },
                            createCashRegister = {
                                deviceType:DeviceTypeEnum,name:String,hardwareId:String,
                                settingsCopyId:String,shopId:String,deactivateAllContent:Boolean->

                                createCashRegister(
                                    deviceType,
                                    name,
                                    hardwareId,
                                    settingsCopyId,
                                    shopId,
                                    deactivateAllContent
                                )

                            }
                        )
                    }


                }
            }



        }



    }
}

@Composable
private fun AddNewCashRegister(
    windowSizeMode: WindowSizeModeEnum,
    loading: Boolean,
    selectedOffice: Children?,
    selectedRegion: ChildrenX?,
    selectedBranch: ChildrenXX?,
    cashList: List<Children>?,
    onSelectOffice: (Children?) -> Unit,
    onSelectRegion: (ChildrenX?) -> Unit,
    onSelectShop: (ChildrenXX?) -> Unit,
    createCashRegister: (DeviceTypeEnum, String, String, String, String, Boolean) -> Unit,
) {
    val name= remember { mutableStateOf("") }
    val hardwareId= remember { mutableStateOf("") }
    val settingsCopyId= remember { mutableStateOf<String?>(null) }
    val deactivateAllContent= remember { mutableStateOf(false) }
    val deviceType= remember { mutableStateOf(DeviceTypeEnum.SMART_CHECKOUT) }

    val itemWidth=when(windowSizeMode){
        WindowSizeModeEnum.PHONE->Dimen.highNormalEditTextWidth
        else ->Dimen.mediumEditTextWidth
    }

    Column(
        modifier = Modifier
            .fillMaxSize()
    )
    {

        Row(
            modifier=Modifier.fillMaxWidth(),
        )
        {
            Column(
                modifier=Modifier
                    .margin(
                        right = Dimen.normalPadding
                    )
                    .width(itemWidth)
            )
            {
                DropDownItem(
                    modifier = Modifier,
                    options=DeviceTypeEnum.entries,
                    itemWidth=itemWidth,
                    label = Strings.current().cashRegisterType,
                    selectedItem =deviceType,
                    displayText = { item ->
                        if (item is DeviceTypeEnum) item.title else ""
                    },
                    onOptionClick = {
                        if (it is DeviceTypeEnum){
                            deviceType.value=it
                        }
                    }
                )


                CustomEditText(
                    value = name.value,
                    marginBottom = 0.px,
                    width = itemWidth,
                    label = Strings.current().name,
                    isRequired = false,
                    onFocusIn = {

                    },
                    onFocusOut = {

                    },
                    onInputChange = {it, validation ->
                        name.value=it
                    }
                )


                CustomEditText(
                    value = hardwareId.value,
                    label = Strings.current().androidSerialNumber,
                    isRequired = false,
                    width =itemWidth,
                    marginBottom =0.px,
                    onFocusIn = {

                    },
                    onFocusOut = {

                    },
                    onInputChange = {it, validation ->
                        hardwareId.value=it
                    }
                )


            }

            Column(
                modifier=Modifier.
                    width(itemWidth)
            )
            {
                DropDownItem(
                    modifier = Modifier,
                    itemWidth=itemWidth,
                    options = cashList ?: listOf(),
                    label = Strings.current().office,
                    selectedItem = selectedOffice,
                    displayText = { item ->
                        if (item is Children) item.name ?: "" else ""
                    },
                    onOptionClick = {
                        if (it is Children)
                             onSelectOffice(it)
                    }
                )

                DropDownItem(
                    modifier = Modifier
                        .margin(top = Dimen.mediumPadding),
                    itemWidth=itemWidth,
                    options = selectedOffice?.children ?: listOf(),
                    label = Strings.current().region,
                    selectedItem = selectedRegion,
                    displayText = { item ->
                        if (item is ChildrenX) item.name ?: "" else ""
                    },
                    onOptionClick = {
                        if (it is ChildrenX)
                            onSelectRegion(it)
                    }
                )

                DropDownItem(
                    modifier = Modifier,
                    itemWidth=itemWidth,
                    options = selectedRegion?.children ?: listOf(),
                    label = Strings.current().branch,
                    selectedItem = selectedBranch,
                    displayText = { item ->
                        if (item is ChildrenXX) item.name ?: "" else ""
                    },
                    onOptionClick = {
                        if (it is ChildrenXX){
                            onSelectShop(it)
                        }
                    }
                )
            }
        }

        DropDownItem(
            modifier = Modifier,
            options= extractAllCashRegisters(cashList),
            label = Strings.current().transferSettingFromCashRegister,
            selectedItem =null,
            displayText = { item ->
                if (item is ChildrenXXX) item.name ?: "" else ""
            },
            onOptionClick = {
                if (it is ChildrenXXX){
                    settingsCopyId.value=it.id
                }

            }
        )



        CheckboxComponent(
            modifier = Modifier.margin(top = Dimen.largePadding),
            title = Strings.current().disableContentOnDevice,
            checkStatus = deactivateAllContent.value,
            onUnChecked = {
                deactivateAllContent.value=false
            },
            onChecked = {
                deactivateAllContent.value=true
            },
        )

        Spacer()

        CustomButton(
            title = Strings.current().save,
            loading = loading,
            isClickable = selectedBranch!=null && name.value.isNotEmpty()
                    && hardwareId.value.isNotEmpty()
                    && settingsCopyId.value!=null,
            buttonType = ButtonTypes.CONTAINED,
            onButtonClick = {
                if (selectedBranch?.id!=null && settingsCopyId.value!=null){

                    createCashRegister(
                        deviceType.value,
                        name.value,
                        hardwareId.value,
                        settingsCopyId.value!!,
                        selectedBranch.id,
                        deactivateAllContent.value
                    )
                }

            }
        )



    }

}

@Composable
private fun AddNewBranch(
    selectedOffice: Children?,
    selectedRegion: ChildrenX?,
    loading: Boolean,
    cashList: List<Children>?,
    onSelectOffice: (Children?) -> Unit,
    onSelectRegion: (ChildrenX?) -> Unit,
    createNewShop: (String, String) -> Unit,
) {
    val name= remember { mutableStateOf("") }
    Column(
        modifier = Modifier.fillMaxSize()
    ){

        DropDownItem(
            modifier = Modifier,
            itemWidth = Dimen.mediumEditTextWidth,
            options = cashList ?: listOf(),
            label = Strings.current().office,
            selectedItem = selectedOffice,
            displayText = { item ->
                if (item is Children) item.name ?: "" else ""
            },
            onOptionClick = {
                if (it is Children)
                     onSelectOffice(it)
            }
        )

        DropDownItem(
            modifier = Modifier
                .margin(top = Dimen.mediumPadding),
            itemWidth = Dimen.mediumEditTextWidth,
            options = selectedOffice?.children ?: listOf(),
            label = Strings.current().region,
            selectedItem = selectedRegion,
            displayText = { item ->
                if (item is ChildrenX) item.name ?: "" else ""
            },
            onOptionClick = {
                if (it is ChildrenX)
                    onSelectRegion(it)


            }
        )




        CustomEditText(
            value = name.value,
            label = Strings.current().name,
            isRequired = false,
            marginTop = Dimen.mediumPadding,
            width = Dimen.mediumEditTextWidth,
            onFocusIn = {

            },
            onFocusOut = {

            },
            onInputChange = {it, validation ->
                name.value=it
            }
        )

        Spacer()

        CustomButton(
            title = Strings.current().save,
            loading = loading,
            isClickable = selectedRegion?.id!=null && name.value.isNotEmpty(),
            buttonType = ButtonTypes.CONTAINED,
            onButtonClick = {
                if (selectedRegion?.id!=null && name.value.isNotEmpty())
                    createNewShop(
                        selectedRegion.id,
                        name.value
                    )
            }
        )
    }

}

@Composable
private fun AddNewRegion(
    selectedOffice: Children?,
    cashList: List<Children>?,
    onSelectOffice: (Children?) -> Unit,
    createNewRegion: (String, String) -> Unit,
    loading: Boolean,

    ) {
    val name= remember { mutableStateOf("") }
    Column(
        modifier = Modifier.fillMaxSize()
    ){


        DropDownItem(
            modifier = Modifier,
            itemWidth = Dimen.mediumEditTextWidth,
            options = cashList ?: listOf(),
            label = Strings.current().office,
            selectedItem =selectedOffice,
            displayText = { item ->
                if (item is Children) item.name ?: "" else ""
            },
            onOptionClick = {
                if (it is Children)
                    onSelectOffice(it)
            }
        )



        CustomEditText(
            value = name.value,
            label = Strings.current().name,
            isRequired = false,
            marginTop = Dimen.mediumPadding,
            width = Dimen.mediumEditTextWidth,
            onFocusIn = {

            },
            onFocusOut = {

            },
            onInputChange = {it, validation ->
                name.value=it
            }
        )

        Spacer()

        CustomButton(
            title = Strings.current().save,
            loading = loading,
            isClickable =name.value.isNotEmpty() ,
            buttonType = ButtonTypes.CONTAINED,
            onButtonClick = {
                if (selectedOffice?.id!=null && name.value.isNotEmpty())
                    createNewRegion(selectedOffice.id,name.value)
            }
        )
    }

}

@Composable
private fun AddNewBusinessOffice(
    createNewDepartment: (String) -> Unit,
    loading: Boolean,
) {
    val name= remember { mutableStateOf("") }


    Column(
        modifier = Modifier.fillMaxSize()
    ){
        CustomEditText(
            value = name.value,
            label = Strings.current().name,
            isRequired = false,
            width = Dimen.mediumEditTextWidth,
            onFocusIn = {},
            onFocusOut = {},
            onInputChange = {it, validation ->
                name.value=it
            }
        )

        Spacer()

        CustomButton(
            title = Strings.current().save,
            loading = loading,
            isClickable = name.value.isNotEmpty(),
            buttonType = ButtonTypes.CONTAINED,
            onButtonClick = {
                createNewDepartment(name.value)
            }
        )
    }


}

@OptIn(ExperimentalComposeWebApi::class)
@Composable
private fun CashRegisterTypeFilters(
    selectedFilterType: CashRegisterTypeEnum,
    onSelectFilterType: (CashRegisterTypeEnum) -> Unit,
    windowSizeMode: WindowSizeModeEnum,
) {
    val chunk=when(windowSizeMode){
        WindowSizeModeEnum.PHONE->1
        else ->2
    }
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(leftRight = Dimen.mediumPadding),
        horizontalAlignment = Alignment.Start,
    )
    {
        RadioGroup(selectedFilterType.title) {
            CashRegisterTypeEnum.entries.chunked(chunk).forEach { row ->
                Row()
                {
                    row.forEach { filter->
                        Row(
                            verticalAlignment = Alignment.CenterVertically,
                            modifier = Modifier
                                .width(Dimen.cashRegisterTypeTitleWidth)
                                .height(Dimen.radioButtonRowHeight)
                                .cursor(Cursor.Pointer)
                                .onClick {
                                    if (filter!=selectedFilterType)
                                        onSelectFilterType(filter)
                                }
                                .margin(topBottom = Dimen.smallPadding)
                        )
                        {
                            CustomRadioInput(
                                title = filter.title,
                                checked = filter==selectedFilterType,
                                onClick = {
                                    if (filter!=selectedFilterType)
                                        onSelectFilterType(filter)
                                },

                            )

                        }
                    }

                }



            }
        }
    }





}


@Composable
private fun TopToolbar(onDismissDialog: () -> Unit) {
    Row(
        modifier = Modifier
            .padding(
                leftRight = Dimen.mediumPadding,
                topBottom = Dimen.smallPadding,
            )
            .borderBottom(
                width = Dimen.smallThickness,
                color = Theme.ActionDisabledBackground.rgb,
                style = LineStyle.Solid,
            )
            .fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically
    )
    {
        SpanText(
            text = Strings.current().addNewDevice,
            modifier = Modifier
                .fontSize(FontSizes.largeFontSize)
                .fontWeight(FontWeight.Medium)
                .color(Theme.TextPrimary.rgb)
                .fontFamily(FontFamily.Jakarta)
                .lineHeight(FontLineHeight.lineLarge)
                .letterSpacing(LetterSpacing.small)
        )

        Spacer()

        CircleIcon(
            borderColor = Theme.Transparent.rgb,
            img = Res.PathIcon.close,
            onIconClick = {
                onDismissDialog()
            }
        )


    }
}